import React from 'react';
import { Callout, Step, DocHeading } from './components';

function PageHwidIssues() {
  return (
    <div>
      <p className="text-sm text-brand-400 font-medium mb-2">Troubleshooting</p>
      <h1 className="font-display text-3xl font-bold text-white tracking-tight mb-3">HWID Issues</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Your Hardware ID (HWID) is automatically generated from your PC components and is used
        to bind your license to a single machine.
      </p>

      <DocHeading>What is HWID?</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        HWID is a fingerprint derived from your CPU, motherboard, and OS installation. It is
        recorded the first time you run the loader with an active subscription. Each license
        key can only be bound to <strong className="text-white">one HWID</strong>.
      </p>

      <DocHeading>When Does HWID Change?</DocHeading>
      <ul className="space-y-2 text-sm text-gray-400 mb-6">
        {[
          'Replacing the motherboard or CPU',
          'Reinstalling Windows with a new OS key',
          'Significant hardware upgrades (multiple components at once)',
          'Virtualisation / VM changes that alter the system fingerprint',
        ].map(i => (
          <li key={i} className="flex items-start gap-2">
            <span className="text-brand-400 mt-0.5 flex-shrink-0">→</span>
            {i}
          </li>
        ))}
      </ul>

      <Callout type="warning">
        HWID resets are granted at admin discretion. Abuse of the reset system may result in
        suspension.
      </Callout>

      <DocHeading>Requesting an HWID Reset</DocHeading>
      <Step n={1} title="Open a Discord ticket">
        Go to the #support channel in our Discord server and open a new ticket.
      </Step>
      <Step n={2} title="Provide your username and reason">
        Explain what hardware you changed and why the HWID reset is needed.
        Include any relevant purchase receipts if this is your first reset.
      </Step>
      <Step n={3} title="Wait for admin review">
        Resets are processed within 24 hours. You will be notified in the ticket.
      </Step>
      <Step n={4} title="Re-activate your key">
        After the reset, launch the loader on your new machine — it will automatically bind
        your key to the new HWID on next successful launch.
      </Step>
    </div>
  );
}

export default PageHwidIssues;
